module.exports = "/fonts/vendor/summernote/dist/summernote.ttf?2386dcc57dbd12e2d5e1cfad5d480067";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.ttf
// module id = 87
// module chunks = 0